import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { CuttingCustomHoleSchema } from '../../../models/cutting/cutting-custom-hole-schema.model';
import { CuttingFastenersSet } from '../../../models/cutting/cutting-fasteners-set.model';
import { FastenerSessionStorageManager, FastenerType } from './fastener-session-storage-manager.helper';

@Component({
  selector: 'csl-fastener-selection',
  templateUrl: './fastener-selection.component.html',
  styleUrls: ['./fastener-selection.component.scss'],
})
export class FastenerSelectionComponent implements OnInit {
  @Input() schemas: CuttingCustomHoleSchema[] = [];
  @Input() fastenerSets: CuttingFastenersSet[] = [];

  @Output() formChanged: EventEmitter<CuttingCustomHoleSchema | CuttingFastenersSet> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  onHoleSchemaChanged(schema: CuttingCustomHoleSchema): void {
    FastenerSessionStorageManager.lastSelectedFastener = { id: schema.id, type: FastenerType.Hole };
    this.formChanged.next(schema);
  }

  onFastenersSetChanged(set: CuttingFastenersSet): void {
    FastenerSessionStorageManager.lastSelectedFastener = { id: set.id, type: FastenerType.FastenerSet };
    this.formChanged.next(set);
  }
}
